/**
 * PostAttachment 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * PostAttachment
 */
export interface PostAttachment {
  /** 附件类型 */
  type?: string
  /** 文件ID */
  file_id?: string
  /** 文件URL */
  url?: string
  /** 缩略图URL */
  thumb_url?: string
  /** 封面URL */
  cover_url?: string
  /** 宽度 */
  width?: number
  /** 高度 */
  height?: number
  /** 文件大小 */
  size?: number
  /** 时长 */
  duration?: number
}

/**
 * PostAttachment Schema
 */
export const PostAttachmentSchema: SchemaDefinition = {
  properties: {
    type: {
      description: '附件类型',
      format: 'cons.PostAttachmentType',
      type: 'string',
      label: '附件类型',
    },
    file_id: {
      description: '文件ID',
      format: '*string',
      type: 'string',
      label: '文件ID',
    },
    url: {
      description: '文件URL',
      format: '*string',
      type: 'string',
      label: '文件URL',
    },
    thumb_url: {
      description: '缩略图URL',
      format: '*string',
      type: 'string',
      label: '缩略图URL',
    },
    cover_url: {
      description: '封面URL',
      format: '*string',
      type: 'string',
      label: '封面URL',
    },
    width: {
      description: '宽度',
      format: '*int',
      type: 'integer',
      label: '宽度',
    },
    height: {
      description: '高度',
      format: '*int',
      type: 'integer',
      label: '高度',
    },
    size: {
      description: '文件大小',
      format: '*int64',
      type: 'integer',
      label: '文件大小',
    },
    duration: {
      description: '时长',
      format: '*int64',
      type: 'integer',
      label: '时长',
    },
  },
  type: 'object',
}
